import Button from "../../Button";
import Logo from "../../Admin/Header/Svg/Logo";
import { getDataFromStorage } from "../../../util";
import React, { useContext, useEffect } from "react";
import Profile from "../../../assets/images/profile.png";
import AlertContext from "../../../context/AlertContext";
import MicSvgIcon from "../../../Svg/Interview/MicSvgIcon";
import FlagSvgIcon from "../../../Svg/Interview/FlagSvgIcon";
import TickSvgIcon from "../../../Svg/Interview/TickSvgIcon";
import InterviewHooks from "../../../Hooks/AI/InterviewHooks";
import InterviewBodyHooks from "../../../Hooks/AI/InterviewBodyHooks";
import { useVoiceVisualizer, VoiceVisualizer } from "react-voice-visualizer";
import { StudentTestPageContext } from "../../../context/StudentTestPageContext";

export default function InterviewBody() {
  const Alert = useContext(AlertContext);
  const StudentTestPageCxt = useContext(StudentTestPageContext);

  const InterviewHks = InterviewHooks();
  const InterviewBodyHks = InterviewBodyHooks();
  const recorderControls = useVoiceVisualizer();

  const { error, recordedBlob, stopRecording, startRecording } =
    recorderControls;

  useEffect(() => {
    const container = InterviewHks.containerRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }, [InterviewHks.containerRef]);

  useEffect(() => {
    if (!recordedBlob) return;

    InterviewHks.stopAudioRecording(recordedBlob);
  }, [recordedBlob, error]);

  useEffect(() => {
    if (
      InterviewHks.previewStream &&
      StudentTestPageCxt.videoRef.current &&
      StudentTestPageCxt.videoRef.current.srcObject?.active !==
        InterviewHks.previewStream?.active
    ) {
      StudentTestPageCxt.videoRef.current.srcObject =
        InterviewHks.previewStream;
    }
  }, [InterviewHks.previewStream]);

  useEffect(() => {
    StudentTestPageCxt.setCurrentQnData(
      Alert.comingObj.sections[0].questions[StudentTestPageCxt.currentQnIndex]
    );
    InterviewHks.playQns(
      Alert.comingObj.sections[0].questions[StudentTestPageCxt.currentQnIndex],
      { from: "qns", startAudioRecording: startRecording }
    );
  }, [StudentTestPageCxt.currentQnIndex]);

  useEffect(() => {
    if (
      !Alert.buttonDisable &&
      !StudentTestPageCxt.showButton.next &&
      !StudentTestPageCxt.showButton.last &&
      !StudentTestPageCxt.currentQnData.hasOwnProperty("actualscore")
    ) {
      const handleQnTimeLimit = setInterval(() => {
        if (StudentTestPageCxt.currentQnData.qnduration === 0) {
          StudentTestPageCxt.recognitionRef.current = "currentQnsAuto";
          stopRecording();
          clearInterval(handleQnTimeLimit);
        } else {
          StudentTestPageCxt.setCurrentQnData((prev) => ({
            ...prev,
            qnduration: prev.qnduration - 1,
          }));
        }
      }, 1000);

      return () => {
        clearInterval(handleQnTimeLimit);
      };
    }
  }, [
    Alert.buttonDisable,
    StudentTestPageCxt.showButton,
    StudentTestPageCxt.currentQnData.qnduration,
  ]);

  return (
    <div className="interviewBodyMain">
      <div className="interviewBodyMainQuestionDiv">
        <div className="interviewBodyMainLogoDiv">
          <Logo
            component="interview"
            className={`interviewBodyMainLogo ${
              StudentTestPageCxt.isSpeaking.question ? "pulse" : ""
            }`}
          />
        </div>
        <div className="interviewBodyMainQuestion">
          {StudentTestPageCxt.currentQnData.name}
        </div>
      </div>
      <div className="interviewBodyMainAnswerDiv">
        {StudentTestPageCxt.transcript.current !== "" ||
        StudentTestPageCxt.currentQnData.hasOwnProperty("actualscore") ? (
          <img
            className="interviewBodyMainUserImg"
            src={Alert.comingObj.picture ?? localStorage.getItem("picture") ?? Profile}
            alt={getDataFromStorage("name").substring(0, 1).toUpperCase()}
          />
        ) : (
          <MicSvgIcon />
        )}
        <div className="interviewBodyMainAnswer">
          {StudentTestPageCxt.isSpeaking.question ? (
            "Recording response"
          ) : !recordedBlob &&
            StudentTestPageCxt.transcript.current === "" &&
            !StudentTestPageCxt.currentQnData.hasOwnProperty("actualscore") ? (
            <VoiceVisualizer
              gap={1}
              speed={3}
              rounded={5}
              barWidth={3}
              width="320px"
              height="60px"
              mainBarColor="#F55533"
              isDefaultUIShown={false}
              backgroundColor="#FFFFFF"
              secondaryBarColor="#F55533"
              controls={recorderControls}
              defaultAudioWaveIconColor="#F55533"
              isProgressIndicatorTimeShown={false}
              defaultMicrophoneIconColor="#F55533"
              key={StudentTestPageCxt.currentQnIndex}
            />
          ) : StudentTestPageCxt.transcript.current !== "" ||
            StudentTestPageCxt.currentQnData.hasOwnProperty("actualscore") ? (
            StudentTestPageCxt.transcript.current !== "" ? (
              StudentTestPageCxt.transcript.current
            ) : (
              "No data to show"
            )
          ) : (
            "Processing"
          )}
          {(StudentTestPageCxt.currentQnData.report ||
            !StudentTestPageCxt.currentQnData.hasOwnProperty(
              "actualscore"
            )) && (
            <div
              className={
                StudentTestPageCxt.transcript.current === ""
                  ? "interviewBodyMainAnswerLabel"
                  : "interviewBodyMainTranscriptLabel"
              }
            >
              {!recordedBlob && StudentTestPageCxt.transcript.current === ""
                ? "Press the ✓ button once you've responded."
                : StudentTestPageCxt.currentQnData.report
                ? "You have already marked this transcript as report, which is not correct."
                : StudentTestPageCxt.transcript.current !== "" &&
                  !StudentTestPageCxt.currentQnData.hasOwnProperty(
                    "actualscore"
                  ) &&
                  `Report major discrepancies only. We'll verify with the recorded audio. Minor spelling errors will be auto-corrected.
                      `}
              {!StudentTestPageCxt.currentQnData.report &&
                StudentTestPageCxt.transcript.current !== "" && (
                  <Button
                    size="sm"
                    onClick={InterviewBodyHks.handleReport}
                    icon={{ type: "leading", icon: <FlagSvgIcon /> }}
                    hierarchy={{
                      buttonText: "Report",
                      type: "secondaryGrey",
                    }}
                  />
                )}
            </div>
          )}
        </div>
        {!StudentTestPageCxt.showButton.next &&
          !StudentTestPageCxt.showButton.last &&
          StudentTestPageCxt.transcript.current === "" && (
            <TickSvgIcon
              data={{
                onClick: () => stopRecording(),
                class: recordedBlob && !StudentTestPageCxt.isSpeaking.question,
                disable:
                  Alert.buttonDisable || StudentTestPageCxt.isSpeaking.question,
              }}
            />
          )}
      </div>
      {(StudentTestPageCxt.showButton.next ||
        StudentTestPageCxt.showButton.last) &&
        !StudentTestPageCxt.currentQnData.hasOwnProperty("actualscore") && (
          <div className="interviewBodyMainFeedbackDiv">
            <div className="interviewBodyMainLogoDiv">
              <Logo
                component="interview"
                className={`interviewBodyMainLogo ${
                  StudentTestPageCxt.isSpeaking.feedback ? "pulse" : ""
                }`}
              />
            </div>
            <div className="interviewBodyMainFeedback">
              {InterviewHks.handleFeedBack()}
            </div>
          </div>
        )}
    </div>
  );
}
